import orderTranslationsHelper from "../../../../../../languages/order-translations.helper";
import OrderCargoOrderFinishedDownloadResponse from "../../../../../api/raily/order/cargo-order/finished/download/order-cargo-order-finished-download.response";
import PublicStatus from "../../../../../types/public-status";
import OrderCargoOrderFinishedDownload from "./order-cargo-order-finished-download";

const createPublicStatus = (
  publicStatus: PublicStatus,
  publicStatusesTranslations: Record<string, string>,
): string => {
  switch (publicStatus) {
    case PublicStatus.PRIVATE:
      return publicStatusesTranslations.private;
    case PublicStatus.PUBLIC:
      return publicStatusesTranslations.public;
    case PublicStatus.PUBLISHED:
      return publicStatusesTranslations.published;
    default:
      return "undefined";
  }
};

const create = (
  response: OrderCargoOrderFinishedDownloadResponse,
): OrderCargoOrderFinishedDownload => {
  const translations =
    orderTranslationsHelper.getFinishedListingTranslations().publicStatuses;

  let reportContent = response.data;

  Object.values(PublicStatus).forEach((publicStatus) => {
    reportContent = reportContent.replace(
      new RegExp(`CargoOrderType.${publicStatus}`, "g"),
      createPublicStatus(publicStatus, translations),
    );
  });

  return {
    data: new Blob([reportContent], { type: "text/csv;charset=utf8" }),
    filename: "",
  };
};

const orderCargoOrderFinishedDownloadFactory = {
  create,
};

export default orderCargoOrderFinishedDownloadFactory;
